import * as R from "ramda";
import React, {Component} from "react";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleDDL from "../../../modules/SimpleDDL";
import FlexView from "react-flexview";
import SimpleButton from "../../../modules/commons/SimpleButton";
import Api from "../../../Services/Api";
import {mapToObjectDDL} from "../../common/mapper";

class MasterPartFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryOptions: [],
      satuanOptions: [],
    };
  }

  async componentDidMount() {
    this.fetchCategoryOptions();
    this.fetchSatuanOptions();
  }

  fetchCategoryOptions = async () => {
    try {
      let response = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).getAllBizparByParam({
        paramFilters: { bizparCategory: "PART_TYPE" },
      });

      if (response.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          categoryOptions: response.data.data.map((item) =>
            mapToObjectDDL(item.value, item.key)
          ),
        }));
      }
    } catch (error) {
      console.log("errors:", error);
    }
  };

  fetchSatuanOptions = async () => {
    try {
      let response = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).getAllBizparByParam({
        paramFilters: { bizparCategory: "UNIT_TYPE" },
      });

      if (response.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          satuanOptions: response.data.data.map((item) =>
            mapToObjectDDL(item.value, item.key)
          ),
        }));
      }
    } catch (error) {
      console.log("errors:", error);
    }
  };

  getDataValue = (fieldName, fallbackValue = "") => {
      return !R.isNil(this.props.state.filterData) && this.props.state.filterData[fieldName]
        ? this.props.state.filterData[fieldName]
        : fallbackValue;
  };

  handleValueChange = (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleReset = () => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {},
    }));
  };

  handleSubmit = () => {
    this.props.onSubmit();
  };

  render() {
    return (
      <SimpleModal
        title="Filter Search"
        visible={this.props.state.filterVisible}
        onClickClose={() => this.props.onClickClose()}
        content={
          <ModalContainer>
              <SimpleInput
                id="input_text_kode_part"
                name="kodePart"
                label="Kode Part"
                value={this.getDataValue("kodePart")}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_part_name"
                name="partName"
                label="Nama Part"
                value={this.getDataValue("partName")}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleDDL
                id="select_options_part_category"
                box="search"
                name="partCategory"
                label="Kelompok Part"
                isClearable
                options={this.state.categoryOptions}
                value={this.getDataValue("partCategory")}
                onChange={(value, { name }) =>
                  this.handleValueChange(name, value)
                }
              />
              <SimpleDDL
                id="select_options_satuan"
                box="search"
                name="satuan"
                label="Satuan"
                isClearable
                options={this.state.satuanOptions}
                value={this.getDataValue("satuan")}
                onChange={(value, { name }) =>
                  this.handleValueChange(name, value)
                }
              />
              <FlexView hAlignContent="right">
                <SimpleButton
                  type="button"
                  secondary
                  onClick={this.handleReset}
                >
                  Reset
                </SimpleButton>
                <SimpleButton onClick={this.handleSubmit}>Terapkan</SimpleButton>
              </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

export default MasterPartFilter;
